import { CartAddEvent } from '../../assets/events';

class ByoMenu extends HTMLElement {

  #abortController = new AbortController();

  constructor() {
    super();
  }

  connectedCallback() {
// Restore cart from localStorage if available
    let storedCart = [];
    try {
      const stored = localStorage.getItem('dff-byom');
      if (stored) {
        storedCart = JSON.parse(stored).map(item => ({
          id: item.id || '',
          quantity: item.quantity || 0,
        }));
      }
    }
    catch (e) {
      console.error('Failed to load cart from localStorage', e);
    }
    this.cart = storedCart;
    this.variants = {};
    this.animateAddToCart = this.dataset.addToCartAnimation === 'true';
    this.hamperTotalPrice = 0;
    this.selectedProducts = [];
    this.tabMenuButtons = this.querySelectorAll('.byo-menu__product');
    this.tabMenuButtons.forEach(el => el.addEventListener('click', this.handleMenuTabClick.bind(this)));
    this.products = this.querySelectorAll('.byo-menu-product');
    this.loader = this.querySelector('.byo-menu__products .loader');
    this.addToCartButton = this.querySelector('.add-to-cart-button');
    this.addToCartButton.addEventListener('click', this.addAllToCart.bind(this));
    this.menuTotalProductsElement = this.querySelector('.byo-menu__total-products');
    this.menuTotalPriceElement = this.querySelector('.byo-menu__total-price');
    this.dialog = this.querySelector('dialog');
    this.panel = this.querySelector('.byo-menu__panel');
    this.panelCaret = this.querySelector('.byo-menu__panel-caret');
    this.panelClose = this.querySelector('.byo-menu__panel-header .icon-close');
    this.panelList = this.querySelector('.byo-menu__panel-list');
    this.panelOpen = false;
    this.setupVariantData();
    this.setupEventListeners();
    this.updateTotal();
    this.panelCaret.addEventListener('click', this.togglePanel.bind(this));
    this.panelClose.addEventListener('click', this.togglePanel.bind(this));
    this.panelCaret.addEventListener('keydown', ( e ) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.togglePanel();
      }
    });
    this.cartItems = [];
    this.updateCartItems();
    this.checkNavActive();

  }

  checkNavActive() {
    const params = new URLSearchParams(window.location.search);
    const activeHandle = params.get('active');
    if (activeHandle) {
      const button = document.querySelector(`.byo-menu__product[data-handle="${activeHandle}"]`);
      if (button) {
        button.click();
      }
    }
  }

  handleDocumentClick = ( event ) => {
    // If click is outside the panel and caret, close the panel
    if (
      this.panelOpen &&
      !this.panel.contains(event.target) &&
      !this.panelCaret.contains(event.target)
    ) {
      this.togglePanel();
    }
  };

  handleMenuTabClick( event ) {
    if (event.target.classList.contains('button-active')) {
      return;
    }
    this.tabMenuButtons.forEach(el => {
      el.classList.remove('button-active');
    });
    event.target.classList.add('button-active');
    // Support productId as a single ID or comma-separated list
    const tabMenuHandle = event.target.dataset.handle;
    const tabMenuProducts = this.querySelectorAll(`div[data-menu-handle]`);

    // Show/hide products based on array of IDs
    tabMenuProducts.forEach(div => {
      if (div.dataset.menuHandle === tabMenuHandle) {
        div.classList.remove('hidden');
      }
      else {
        div.classList.add('hidden');
      }
    });

    // Update URL with comma-separated list if multiple IDs
    const url = new URL(window.location);
    url.searchParams.set('active', tabMenuHandle);
    window.history.replaceState({}, '', url);
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  setupVariantData() {
    const variants = this.querySelectorAll('.quick-order-variant');
    variants.forEach(variant => {
      const variantId = variant.dataset.variantId;
      const price = parseInt(variant.dataset.variantPrice, 10);
      this.variants[variantId] = {
        productTitle: variant.dataset.variantProductTitle,
        title: variant.dataset.variantTitle,
        price: price,
      };
    });

  }

  setupEventListeners() {
    const { signal } = this.#abortController;
    this.addEventListener('click', this.handleButtonClick.bind(this), { signal });
    this.addEventListener('change', this.handleQuantityChange.bind(this), { signal });
  }

  handleButtonClick( event ) {
    const target = event.target;

    if (target.classList.contains('quick-order-increase')) {
      this.updateQuantity(target.dataset.variantId, 1);
    }
    else if (target.classList.contains('quick-order-decrease')) {
      this.updateQuantity(target.dataset.variantId, -1);
    }
    else if (target.classList.contains('quick-order-add-all-button')) {
      void this.addAllToCart();
    }
  }

  handleQuantityChange( event ) {
    if (event.target.classList.contains('quick-order-quantity-input')) {
      const moq = parseInt(event.target.dataset.moq) || 1;
      const variantId = event.target.dataset.variantId;
      let quantity = parseInt(event.target.value) || 0;

      if (quantity > 0 && quantity < moq) {
        quantity = moq;
        event.target.value = moq;
      }

      this.setQuantity(variantId, quantity);
      this.updateTotal();
      this.updateAddAllButton();
    }
  }

  updateQuantity( variantId, change ) {
    const input = this.querySelector(`input[data-variant-id="${variantId}"]`);
    if (input) {
      const moq = parseInt(input.dataset.moq);
      const currentValue = parseInt(input.value) || 0;

      let initValue = currentValue;
      let newValue = currentValue;

      if (change === 1) {
        newValue = currentValue === 0 ? moq : currentValue + 1;
      }
      else if (change === -1) {
        newValue = currentValue === moq ? 0 : Math.max(0, currentValue - 1);
      }

      input.value = newValue;
      if (!(initValue === 0 && change === -1) && this.animateAddToCart) {
        this.#animateFlyToDrawer(input, change);
      }
      this.setQuantity(variantId, newValue);
    }
  }

  setQuantity( variantId, quantity ) {
    const existingIndex = this.cart.findIndex(item => item.id === variantId);

    if (quantity > 0) {
      if (existingIndex >= 0) {
        this.cart[existingIndex].quantity = parseInt(quantity);
      }
      else {
        this.cart.push({
          id: variantId,
          quantity: parseInt(quantity),
        });
      }
    }
    else {
      if (existingIndex >= 0) {
        this.cart.splice(existingIndex, 1);
      }
    }

    this.updateCartItems();
    this.updateTotal();
    this.updateAddAllButton();
  }

  updateCartItems() {
    // Build cartItems as array of {title, quantity, linePrice}
    this.cartItems = this.cart.map(item => {
      const productTitle = this.getProductTitle(item.id) || '';
      const title = this.getVariantTitle(item.id) || '';
      const quantity = item.quantity;
      const price = this.variants[item.id] ? this.variants[item.id].price : 0;
      const linePrice = price * quantity;
      return {
        productTitle,
        title,
        quantity,
        linePrice,
      };
    });
    // Persist cartItems to localStorage
    try {
      localStorage.setItem('dff-byom', JSON.stringify(this.cart));
    }
    catch (e) {
      // Optionally handle quota exceeded or other errors
      console.error('Failed to save cartItems to localStorage', e);
    }
    this.updateCartItemsSummary();
  }

  updateCartItemsSummary() {
    const panelInner = this.panel.querySelector('.byo-menu__panel-inner');
    if (!panelInner) {
      return;
    }
    let summaryDiv = panelInner.querySelector('.panel-items');
    if (!summaryDiv) {
      summaryDiv = document.createElement('div');
      summaryDiv.className = 'panel-items';
      panelInner.prepend(summaryDiv);
    }
    if (this.cartItems.length === 0) {
      summaryDiv.innerHTML = '<em>No items added yet.</em>';
      return;
    }
    // Get delete icon SVG markup from template
    const iconTemplate = document.getElementById('panel-delete-icon-template');
    const iconSVG = iconTemplate ? iconTemplate.innerHTML : '';
    summaryDiv.innerHTML = this.cartItems.map(( item, idx ) => {
      const variantTitle = item.title === 'Default Title' ? '' : item.title;
      return `
      <div class="panel-item">
        <span class="item-product-title">${item.productTitle}</span>
        <span class="item-title">${variantTitle}</span>
        <span class="item-qty">×${item.quantity}</span>
        <span class="item-price">${new Intl.NumberFormat('en-GB',
        { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(item.linePrice / 100)}</span>
        <span class="item-action"><button class="button-unstyled panel-delete-btn" data-index="${idx}" title="Remove item">${iconSVG}</button></span>
      </div>
    `;
    }).join('');
    // Add event listeners for delete buttons
    summaryDiv.querySelectorAll('.panel-delete-btn').forEach(btn => {
      btn.addEventListener('click', ( e ) => {
        e.preventDefault();
        const index = parseInt(btn.dataset.index);
        if (!isNaN(index)) {
          // Remove the item from the cart by variant id
          const item = this.cart[index];
          if (item) {
            // Set corresponding quantity input to 0 without firing onChange
            const input = this.querySelector(`input[data-variant-id="${item.id}"]`);
            if (input) {
              input.value = 0;
            }
            this.removeCartItemByIndex(index);
          }
        }
      });
    });
  }

  removeCartItemByIndex( index ) {
    if (index >= 0 && index < this.cart.length) {
      this.cart.splice(index, 1);
      this.updateCartItems();
      this.updateTotal();
      this.updateAddAllButton();
    }
  }

  updateTotal() {
    let total = 0;
    let totalQuantity = 0;
    this.cart.forEach(item => {
      if (this.variants[item.id]) {
        total += this.variants[item.id].price * item.quantity;
        totalQuantity += item.quantity;
      }
    });
    const quantityElement = this.querySelector('.byo-menu__total-products');
    if (quantityElement) {
      quantityElement.textContent = totalQuantity;
    }
    const totalElement = this.querySelector('.byo-menu__total-price');
    if (totalElement) {
      totalElement.textContent = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
      }).format(total / 100);
    }
  }

  updateAddAllButton() {
    const button = this.querySelector('.add-to-cart-button');
    if (button) {
      button.disabled = this.cart.length === 0;
    }
  }

  togglePanel() {
    this.panelOpen = !this.panelOpen;
    this.panel.classList.toggle('open', this.panelOpen);
    this.panelCaret.classList.toggle('open', this.panelOpen);
    this.panel.setAttribute('aria-hidden', !this.panelOpen);
    if (this.panelOpen) {
      this.populatePanelList();
      this.panel.querySelector('.byo-menu__panel-inner').focus?.();
      document.addEventListener('mousedown', this.handleDocumentClick);
    }
    else {
      document.removeEventListener('mousedown', this.handleDocumentClick);
    }
  }

  populatePanelList() {
    if (!this.panelList) {
      return;
    }
    this.panelList.innerHTML = '';
    if (this.cart.length === 0) {
      const li = document.createElement('li');
      li.textContent = 'No items added yet.';
      this.panelList.appendChild(li);
      return;
    }
    this.cart.forEach(item => {
      const li = document.createElement('li');
      const title = document.createElement('span');
      title.className = 'item-title';
      title.textContent = this.getVariantTitle(item.id) || item.id;
      const qty = document.createElement('span');
      qty.className = 'item-qty';
      qty.textContent = `×${item.quantity}`;
      const price = document.createElement('span');
      price.className = 'item-price';
      price.textContent = this.variants[item.id] ? new Intl.NumberFormat('en-GB',
        { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(
        this.variants[item.id].price * item.quantity / 100) : '';
      li.appendChild(title);
      li.appendChild(qty);
      li.appendChild(price);
      this.panelList.appendChild(li);
    });
  }

  getProductTitle( variantId ) {
    return this.variants[variantId].productTitle;
  }

  getVariantTitle( variantId ) {
    return this.variants[variantId].title;
  }

  #animateFlyToCart() {
    const addToCartButton = this.querySelector('.add-to-cart-button');
    const cartIcon = document.querySelector('.header-actions__cart-icon');

    const image = this.querySelector('.quick-order-variant-image img').src;

    if (!cartIcon || !addToCartButton || !image) {
      return;
    }

    const flyToCartElement = /** @type {FlyToCart} */ (document.createElement('fly-to-cart'));

    flyToCartElement.style.setProperty('background-image', `url(${image})`);
    flyToCartElement.source = addToCartButton;
    flyToCartElement.destination = cartIcon;

    document.body.appendChild(flyToCartElement);
  }

  #animateFlyToDrawer( source, change ) {
    const drawer = document.querySelector('.byo-menu__total-price');
    // find the image closest to the input
    let image = source.closest('.quick-order-variant').querySelector('.quick-order-variant-image img');
    if (!image) {
      //if there's not a product image then use the first one available
      image = this.querySelector('.quick-order-variant-image img');
    }

    if (!drawer || !source || !image) {
      return;
    }

    const flyToCartElement = /** @type {FlyToCart} */ (document.createElement('fly-to-cart'));

    flyToCartElement.style.setProperty('background-image', `url(${image.src})`);
    if (change === 1) {
      flyToCartElement.source = source;
      flyToCartElement.destination = drawer;
    }
    else {
      flyToCartElement.source = drawer;
      flyToCartElement.destination = source;
    }

    document.body.appendChild(flyToCartElement);
  }

  async addAllToCart() {
    if (this.cart.length === 0) {
      return;
    }

    const button = this.querySelector('.add-to-cart-button');

    if (!button) {
      console.error('Add all button not found');
      return;
    }

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: this.cart,
        }),
      });

      if (!response.ok) {
        let errorMsg = 'Failed to add items to cart';

        try {
          const errorData = await response.json();
          errorMsg = errorData.message || errorMsg;
        }
        catch {
          // Ignore JSON parse errors
        }
        throw new Error(errorMsg);
      }

      const newCart = await fetch(window.Shopify.routes.root + 'cart.js');
      const newCartObject = await newCart.json();

      this.cart = [];
      this.updateCartItems();
      this.querySelectorAll('.quick-order-quantity-input').forEach(input => {
        input.value = '0';
      });
      this.updateTotal();
      this.updateAddAllButton();
      button.textContent = originalText;
      if (this.animateAddToCart) {
        this.#animateFlyToCart();
      }
      this.dispatchEvent(
        new CartAddEvent({}, null, {
          source: 'canape-menu-builder',
          itemCount: newCartObject.item_count,
        }),
      );
    }
    catch (error) {
      console.error('Error adding to cart:', error);
      button.textContent = 'Error - Try again';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    }
  }

}

customElements.define('byo-menu', ByoMenu);
